import React, { useRef } from 'react'

import { FormattedMessage } from 'react-intl'

import HubSpotForm from 'components/HubSpotForm'
import { StyledContent } from 'components/Modal/Modal/styles'
import { StyledModal, CloseButton } from 'components/Modal/styles'
import { Container } from 'components/Grid'
import XIcon from 'static/img/x_icon_dark.svg'

const HubSpotFormModal = ({ handleCloseModal, content }) => {
  const modalRef = useRef(null)
  const signUpForm = [...content.signup_form].pop()
  return (
    <StyledModal ref={modalRef}>
      <StyledContent preset="splash_form">
        <Container>
          <h4>
            <FormattedMessage id="register" />
          </h4>
        </Container>
        <HubSpotForm blok={signUpForm} eventCardData={content} />
        <CloseButton onClick={handleCloseModal}>
          <img src={XIcon} width={22} />
        </CloseButton>
      </StyledContent>
    </StyledModal>
  )
}

export default HubSpotFormModal
